import { motion } from "framer-motion";
import Container from "../../components/ui/container";
import { Card, CardContent } from "../../components/ui/card";
import { DollarSign, Clock, Shield, Users, Scale, Coins, Users2, BarChart } from "lucide-react";

const benefits = [
  {
    icon: DollarSign,
    title: "Cost-Effective Solutions",
    description: "Optimize your operational costs while maintaining exceptional quality of work"
  },
  {
    icon: Scale,
    title: "Legal Compliance",
    description: "We provide comprehensive legal compliance support, ensuring adherence to international employment laws"
  },
  {
    icon: Coins,
    title: "Payroll Management",
    description: "We manage payroll processing and taxes to ensure compliance for your international employees"
  },
  {
    icon: Clock,
    title: "Quick Matching",
    description: "Get matched with the perfect talent within 48 hours"
  },
  {
    icon: Shield,
    title: "Pre-vetted Talent",
    description: "Thoroughly vetted professionals with proven expertise in their fields"
  },
  {
    icon: Users,
    title: "Global Talent Pool",
    description: "Access to skilled professionals from around the world"
  },
  {
    icon: Users2,
    title: "Specialist Engagement",
    description: "We foster specialist engagement through tailored solutions and collaboration"
  },
  {
    icon: BarChart,
    title: "HR Support",
    description: "Enhance productivity with our managed HR services and remote work solutions"
  }
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-20 bg-gray-50">
      <Container>
        <div className="text-center max-w-2xl mx-auto mb-12">
          <motion.h2 
            className="text-3xl font-bold"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Why Choose OutsourceHub
          </motion.h2>
          <motion.p 
            className="mt-4 text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            We connect you with exceptional remote talent while ensuring significant cost savings
          </motion.p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="h-full"
            >
              <Card className="h-full hover:shadow-lg transition-shadow">
                <CardContent className="pt-6 flex flex-col h-full">
                  <div className="bg-primary/10 rounded-full p-3 w-fit mb-4">
                    <benefit.icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground flex-grow">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}